// @flow

import React from 'react';
import {Field, reduxForm} from 'redux-form';
import BasicFormInput from '../BasicFormInput/BasicFormInput';
import SelectFormInput from '../SelectFormInput/SelectFormInput';
import TextAreaFormInput from '../TextAreaFormInput/TextAreaFormInput';
import {assortments} from '../../assortments';
import RelatedVariantsInput from '../RelatedVariantsInput/RelatedVariantsInput';

export type Props = {
  productTypes: any[],
  workerTypes: any[],
  roomTypes: any[],
  onUserChange: Function,
  variants: any[],
  suppliers: any[],
  relatedProductTypes: any[],
  relatedProductType: ?{ id: number },
  related: any[],
  relatedProductSelected: Function,
  relatedVariantSelected: Function,
  relatedProductToggle: Function,
  relatedProductTypeToggle: Function,
  addRelatedProductType: Function,
  setRelatedProductType: Function,
  relatedProductTypeSelected: Function,
  removeProductType: Function,
  unlockShared: Function,
  hasVariantDiffs: boolean,
};

const ProductForm = ({
  productTypes,
  workerTypes,
  roomTypes,
  variants,
  suppliers,
  onUserChange,
  relatedProductTypes,
  relatedProductType,
  related,
  relatedProductSelected,
  relatedVariantSelected,
  relatedProductToggle,
  relatedProductTypeToggle,
  addRelatedProductType,
  setRelatedProductType,
  relatedProductTypeSelected,
  removeProductType,
  unlockShared,
  hasVariantDiffs,
}: Props) => (
  <div className="ProductForm">
    <form>
      <div className="row">
        <div className="small-6 column">
          <Field
            name="name"
            label="Namn"
            onChange={onUserChange}
            component={BasicFormInput}
            type="text" />
          <Field
            name="productTypeId"
            label="Produkttyp"
            normalize={value => value ? value.id : null}
            onChange={onUserChange}
            component={SelectFormInput}
            valueKey="id"
            labelKey="name"
            options={productTypes} />
          <Field
            name="supplierId"
            label="Leverantör"
            normalize={value => value ? value.id : null}
            onChange={onUserChange}
            component={SelectFormInput}
            valueKey="id"
            labelKey="name"
            options={suppliers} />
          <Field
            name="workerTypes"
            label="Yrkeskategorier"
            onChange={onUserChange}
            component={SelectFormInput}
            valueKey="id"
            labelKey="name"
            options={workerTypes}
            multi={true} />
          <Field
            name="roomTypes"
            label="Rumstyper"
            onChange={onUserChange}
            component={SelectFormInput}
            valueKey="id"
            labelKey="name"
            options={roomTypes}
            multi={true} />
        </div>
        <div className="small-6 column">
          <Field
            name="externalDescription"
            label="Produktbeskrivning"
            onChange={onUserChange}
            component={TextAreaFormInput}
          />
          <Field
            name="internalDescription"
            label="Intern beskrivning"
            onChange={onUserChange}
            component={TextAreaFormInput}
          />
        </div>
      </div>
      <div className="row">
        {variants &&
          <div className="small-6 column">
            <Field
              name="mainVariantId"
              label="Visningsartikel"
              normalize={value => value ? value.id : null}
              onChange={onUserChange}
              component={SelectFormInput}
              valueKey="id"
              labelKey="name"
              options={variants}/>
          </div>
        }
        <div className="small-6 column">
          <Field
            name="assortment"
            label="Sortiment"
            normalize={value => value ? value.id : null}
            onChange={onUserChange}
            component={SelectFormInput}
            valueKey="id"
            labelKey="label"
            options={assortments} />
        </div>
      </div>
      <div className="row related-row">
        <div className="small-12 column">
          <Field
            name="related"
            label="Kombinationsprodukt"
            productTypes={relatedProductTypes}
            relatedProductType={relatedProductType}
            setRelatedProductType={setRelatedProductType}
            addRelatedProductType={addRelatedProductType}
            related={related}
            productSelected={relatedProductSelected}
            variantSelected={relatedVariantSelected}
            productToggle={relatedProductToggle}
            productTypeToggle={relatedProductTypeToggle}
            productTypeSelected={relatedProductTypeSelected}
            removeProductType={removeProductType}
            component={RelatedVariantsInput}
            hasVariantDiffs={hasVariantDiffs}
            unlockShared={unlockShared} />
        </div>
      </div>
    </form>
  </div>
);

export default reduxForm({
  form: 'product',
  enableReinitialize: true,
})(ProductForm);



// WEBPACK FOOTER //
// ./src/components/ProductForm/ProductForm.js